import {
  JaneGoldCard,
  SpecialsGrid as MenuSpecialsGrid,
  SPECIALS_GRID_LIMIT,
  getSpecialSlug,
} from '@iheartjane/menu';
import { Button, Flex } from '@iheartjane/reefer';
import { useState } from 'react';

import { useFullDestination } from '@jane/bloom/hooks/navigation/useFullDestination';
import type { BrandSpecials } from '@jane/bloom/types/schemas/marketplace/brandSpecials';

type JaneGoldGridProps = {
  authenticated?: boolean;
  brandSpecials: BrandSpecials;
};

export function JaneGoldGrid({
  authenticated,
  brandSpecials,
}: JaneGoldGridProps) {
  const [showAll, setShowAll] = useState(false);
  const generatePath = useFullDestination();
  const visibleSpecials = brandSpecials.slice(
    0,
    !showAll ? SPECIALS_GRID_LIMIT : undefined
  );
  const hasMore = !showAll && brandSpecials.length > SPECIALS_GRID_LIMIT;

  if (brandSpecials.length === 0) return null;

  return (
    <div>
      <MenuSpecialsGrid>
        {visibleSpecials.map((special) => (
          <JaneGoldCard
            key={special.id}
            authenticated={authenticated}
            brandImage={special.product_brand.logo_url}
            brandName={special.product_brand.name}
            imageSrc={special.photo?.urls?.original}
            isBundle={special.special_type !== 'product'}
            rules={special.rules}
            specialType={special.special_type}
            tagLabel={special.discount_label}
            title={special.title}
            to={generatePath(
              `/jane-gold/${special.id}/${getSpecialSlug(special.title)}`
            )}
          />
        ))}
      </MenuSpecialsGrid>
      {hasMore && (
        <Flex justifyContent="center" mt={24}>
          <Button
            label="Load more"
            variant="tertiary"
            onClick={() => setShowAll(true)}
          />
        </Flex>
      )}
    </div>
  );
}
